import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { configList, delPoster } from "@/api/Administration/advConfiguration";
import adConfigRt from "./components/adConfigRt";
export default {
  name: "advConfiguration",
  components: {
    adConfigRt: adConfigRt
  },
  data: function data() {
    return {
      tableData: [],
      adConfigRt: false,
      total: 0,
      page: 1,
      showing: false
    };
  },
  created: function created() {
    this.getData();
  },
  methods: {
    handleSource: function handleSource(row) {
      this.$refs.adConfigRt.init(row);
    },
    getData: function getData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                configList().then(function (res) {
                  if (res.status == 1000) {
                    var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
                    _this.tableData = res.data.length ? _this.$utils.dataConversion(res.data, list) : [];
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                delPoster({
                  id: Number(id)
                }).then(function (res) {
                  _this2.getData();

                  _this2.$message({
                    type: "success",
                    message: res.message
                  });
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};